// extracted by mini-css-extract-plugin
export var label = "_f1-2";
export var slideContainer = "_f1-0";
export var slider = "_f1-1";